import { render, staticRenderFns } from "./data-entry-section.vue?vue&type=template&id=4f9fd2bf&scoped=true&"
import script from "./data-entry-section.vue?vue&type=script&lang=js&"
export * from "./data-entry-section.vue?vue&type=script&lang=js&"
import style0 from "./data-entry-section.vue?vue&type=style&index=0&id=4f9fd2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fd2bf",
  null
  
)

export default component.exports